import { getNavigationIcon } from '@/constants/navigationAssets'

import { ParkingTileMobileReview } from '../ParkingTileMobile.styled'

interface MobileRatingType {
  rating?: string
}

const MobileTileRatingContainer: React.FC<MobileRatingType> = ({ rating }) => {
  if (!rating || rating === '0') {
    return <></>
  }

  return (
    <ParkingTileMobileReview>
      <img
        src={getNavigationIcon('starFilled')}
        alt="star rating"
        width={15}
        height={15}
        loading="lazy"
      />
      {rating}
    </ParkingTileMobileReview>
  )
}

export default MobileTileRatingContainer
